<!--
 * @Description: 广水市农业供应链数字平台大数据中心 - 主页面
 * @Author: xiawenlong
 * @Date: 2026-04-01
-->
<template>
  <div class="screen-root-agriculture">
    <div id="screen-agriculture">
      <TopHeader />
      <div class="main-content">
        <!-- 左侧栏 -->
        <div class="left">
          <div class="baseInfo">
            <BaseInfo />
          </div>
          <div class="card-group card-group1">
            <div class="card card1">
              <SaleTypeAmount />
            </div>
            <div class="card card2">
              <SupplierSales />
            </div>
          </div>
          <div class="card card3">
            <PurchasingPie />
          </div>
          <div class="card-group card-group2">
            <div class="card card4">
              <SchoolProcurementRank />
            </div>
            <div class="card card5">
              <SaleProductAmount />
            </div>
          </div>
        </div>

        <!-- 中间区域 -->
        <div class="center">
          <div class="flop-box">
            <dv-border-box-8 :dur="5" class="flop" :color="['transparent', '#fff']">
              <Flop ref="Flop" />
            </dv-border-box-8>
          </div>
          <div class="dataBoard">
            <DataBoard
              ref="DataBoard"
              @product-click="handleProductClick"
              @supplier-click="handleSupplierClick"
              @biz-cus-click="handleBizCusClick"
              @user-cus-click="handleUserCusClick"
              @biz-order-click="handleBizOrderClick"
              @user-order-click="handleUserOrderClick"
              @group-order-click="handleGroupOrderClick"
              @area-company-order-click="handleAreaCompanyOrderClick"
            />
          </div>
          <div class="china-map">
            <ChinaMap />
          </div>
        </div>
        <ProductDialog ref="ProductDialog" />
        <SupplierDialog ref="SupplierDialog" />
        <BizCusDialog ref="BizCusDialog" />
        <UserCusDialog ref="UserCusDialog" />
        <BizOrderDialog ref="BizOrderDialog" />
        <UserOrderDialog ref="UserOrderDialog" />
        <GroupOrderDialog ref="GroupOrderDialog" />
        <AreaCompanyOrderDialog ref="AreaCompanyOrderDialog" />
        <AreaCompanyMapDialog ref="AreaCompanyMapDialog" />
        <!-- 右侧栏 -->
        <div class="right">
          <div class="wrapper">
            <TransactionData />
          </div>
          <div class="wrapper">
            <LatestListing />
          </div>
          <div class="card card1">
            <BrandPromotion />
          </div>
          <div class="card-group">
            <div class="card card2">
              <SupplierService :data="supplierTrainingData" />
            </div>
            <div class="card card3">
              <TalentTraining :data="supplierTrainingData" />
            </div>
          </div>
          <div class="card card4">
            <ProjectDeclaration :data="supplierTrainingData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from './components/TopHeader'
import { platformTotal, supplierTrainingProject } from '@/api/agriculture-dashboard'
import to from '@/utils/await-to'
import { ensureDashboardLogin } from '@/utils/dashboard-auth'
import Flop from './components/Flop'
import DataBoard from './components/DataBoard'
import SupplierSales from './components/SupplierSales'
import SaleTypeAmount from './components/SaleTypeAmount'
import PurchasingPie from './components/PurchasingPie'
import SchoolProcurementRank from './components/SchoolProcurementRank'
import SaleProductAmount from './components/SaleProductAmount'
import BaseInfo from './components/BaseInfo'
import TransactionData from './components/TransactionData'
import LatestListing from './components/LatestListing'
import BrandPromotion from './components/BrandPromotion'
import SupplierService from './components/SupplierService'
import TalentTraining from './components/TalentTraining'
import ProjectDeclaration from './components/ProjectDeclaration'
import ChinaMap from './components/ChinaMap'
import ProductDialog from './dialog/ProductDialog'
import SupplierDialog from './dialog/SupplierDialog'
import BizCusDialog from './dialog/BizCusDialog'
import UserCusDialog from './dialog/UserCusDialog'
import BizOrderDialog from './dialog/BizOrderDialog'
import UserOrderDialog from './dialog/UserOrderDialog'
import GroupOrderDialog from './dialog/GroupOrderDialog'
import AreaCompanyOrderDialog from './dialog/AreaCompanyOrderDialog'
import AreaCompanyMapDialog from './dialog/AreaCompanyMapDialog'
let _timer
export default {
  name: 'AgricultureDashboard',
  components: {
    TopHeader,
    Flop,
    DataBoard,
    SupplierSales,
    SaleTypeAmount,
    PurchasingPie,
    SchoolProcurementRank,
    SaleProductAmount,
    BaseInfo,
    TransactionData,
    LatestListing,
    BrandPromotion,
    SupplierService,
    TalentTraining,
    ProjectDeclaration,
    ChinaMap,
    ProductDialog,
    SupplierDialog,
    BizCusDialog,
    UserCusDialog,
    BizOrderDialog,
    UserOrderDialog,
    GroupOrderDialog,
    AreaCompanyOrderDialog,
    AreaCompanyMapDialog,
  },
  data() {
    return {
      totalData: {},
      supplierTrainingData: {},
    }
  },
  mounted() {
    this.handleScreenAuto()
    window.onresize = () => this.handleScreenAuto()
    this.initNumData()
    this.initSupplierTrainingData()
    _timer = setInterval(() => {
      this.initNumData()
      this.initSupplierTrainingData()
    }, process.env.VUE_APP_LTIME)
  },
  destroyed() {
    clearInterval(_timer)
    window.onresize = null
  },
  methods: {
    async initNumData() {
      const [res, err] = await to(platformTotal({}))
      if (err) return
      this.$refs.DataBoard.initData(res)
      this.$refs.Flop.initData(res.data.platformSaleTotal)
      this.totalData = res.data
    },
    async initSupplierTrainingData() {
      const [res, err] = await to(supplierTrainingProject({}))
      if (err) return
      this.supplierTrainingData = res.data || {}
    },
    // 商品数量点击事件
    async handleProductClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.ProductDialog.show()
    },
    // 供应商数量点击事件
    async handleSupplierClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.SupplierDialog.show()
    },
    // 企业客户数量点击事件
    async handleBizCusClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.BizCusDialog.show()
    },
    // 个人客户数量点击事件
    async handleUserCusClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.UserCusDialog.show()
    },
    // 批发成交点击事件
    async handleBizOrderClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.BizOrderDialog.show()
    },
    // 零售成交点击事件
    async handleUserOrderClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.UserOrderDialog.show()
    },
    // 校园餐销售额点击事件
    handleGroupOrderClick() {
      this.$router.push('/tc')
    },
    // 新型农村集体经济组织点击事件
    async handleAreaCompanyOrderClick() {
      if (!(await ensureDashboardLogin())) return
      this.$refs.AreaCompanyMapDialog.show()
    },
    //数据大屏自适应函数
    handleScreenAuto() {
      const designDraftWidth = 4096 //设计稿的宽度
      const designDraftHeight = 2160 //设计稿的高度
      //根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth / document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight
      //缩放比例
      document.querySelector(
        '#screen-agriculture',
      ).style.transform = `scale(${scale}) translate(-50%)`
    },
  },
}
</script>

<style lang="scss">
.screen-root-agriculture {
  font-family: sans-serif !important;
  color: #fff;
  height: 100%;
  width: 100%;
  background-color: #050d4c;

  #screen-agriculture {
    overflow: hidden;
    display: inline-block;
    width: 4096px; // 设计稿的宽度
    height: 2160px; // 设计稿的高度
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    top: 0;
    background: url('~@/img/agriculture/background.png');

    .main-content {
      width: 100%;
      height: calc(100% - 160px);
      display: flex;
      box-sizing: border-box;
      padding: 0 40px;

      > .left,
      > .right {
        box-sizing: border-box;
        height: 1981px;
      }

      > .center {
        overflow: hidden;
        position: relative;
        flex: 1;
        box-sizing: border-box;
        height: 100%;
      }

      .card {
        width: 100%;
        border-radius: 12px 12px 12px 12px;
        border: 2px solid rgba(0, 107, 252, 0.46);
      }

      .left {
        width: 1176px;
        display: flex;
        flex-direction: column;
        background: url('~@/img/agriculture/left_bg.png') 100% 100%;
        padding: 0 33px 0 31px;

        .card {
          &.card1,
          &.card2 {
            width: 542px;
            height: 325px;
          }

          &.card3 {
            margin-bottom: 16px;
            width: 100%;
            height: 559px;
            border-radius: 12px 12px 12px 12px;
          }

          &.card4,
          &.card5 {
            width: 542px;
            height: 559px;
            border-radius: 12px 12px 12px 12px;
          }
        }

        .card-group {
          justify-content: space-between;
          display: flex;
          width: 100%;

          &.card-group1 {
            margin-bottom: 18px;
          }
        }
      }

      .right {
        width: 1168px;
        display: flex;
        flex-direction: column;
        background: url('~@/img/agriculture/right_bg.png') 100% 100%;
        padding: 20px 51px 0 48px;

        .wrapper {
          margin-bottom: 17px;

          &:last-of-type {
            margin-bottom: 0;
          }
        }

        .card1 {
          height: 633px;
          margin-bottom: 21px;
        }

        .card-group {
          display: flex;
          margin-bottom: 31px;
          justify-content: space-between;
          .card2 {
            width: 526px;
            height: 457px;
          }

          .card3 {
            width: 526px;
            height: 457px;
          }
        }

        .card4 {
          height: 260px;
        }
      }
    }

    .baseInfo {
      height: 474px;
    }

    .center {
      .flop-box {
        padding: 25px 46px 0 39px;
      }

      .flop {
        width: 1587px;
        height: 259px;
      }

      .dataBoard {
        padding: 13px 0 0 44px;
      }

      .china-map {
        margin-top: -34px;
        height: 1400px;
        text-align: center;
        position: relative;
      }
    }
  }
}
</style>
